import { HOME } from "../constants/ActionTypes"

const initialHomeState = {
    BrandList: null,
    SearchTrim: "",
    TopCarousel:[],
    Category:[],
    CategoryHover: null,
    CategoryHoverNickName: null,
    FixedRightTop: null,
    FixedRightBottom: null,
    FixedLeft: null,
    TopMenu: null,
    TopMenuHover:[
        {content:"我的订单", link:"/myOrderList"},
        // { content: "游客订单", link: "javascript:;"}
        /*{content:"我的收藏",link:"/my-account/favorites_1_0.html"}*/
    ],
    NavigationAlphabet: null,
    CategoryScrollTop: [],
    FixedLeftCategory: null,
    SearchInnerFixed: {
        // value: '',
        myTimer: null,
        placeholders: [],
        placeholder: '请输入您要搜索的关键词',
    },
    SearchInnerStatic: {
        // value: '',
        myTimer: null,
        placeholders: [],
        placeholder: '请输入您要搜索的关键词',
    },
    SearchResultsStatic:{
        down: 0,      // 联想词展开层
        results: null,   // 联想词原数据
        suggestList: null,   // 联想词处理后的数据
        suggestProductList: null, // 联想词处理后的数据
        DefaultModule: 0,    // 默认无词展开层
        // DefaultProducts: null, // 默认无词数据
    },
    SearchResultsFixed:{
        down: 0,      // 联想词展开层
        results: null,   // 联想词原数据
        suggestList: null,   // 联想词处理后的数据
        suggestProductList: null, // 联想词处理后的数据
        DefaultModule: 0,    // 默认无词展开层
        // DefaultProducts: null, // 默认无词数据
    },
    // DefaultModule: 0,
    DefaultProducts: null,
    SearchHistory: null,
    SwitchProducts: 0,
    UpDownKeyCodeStatic: null,
    UpDownKeyCodeFixed: null,
    FirstOrderGift: {}
};
export default function ( state = initialHomeState, action = {} ){
    let BrandList = action.BrandIndex;
    let SearchTrim = action.SEARCH_TRIM;
    let TopCarousel = action.TOP_CAROUSEL;
    let CategoryId = action.CATEGORY_ID;
    let CategoryResponse = action.CATEGORY_RESPONSE;
    let CategoryHover = action.CATEGORY_HOVER;
    let CategoryHoverNickName = action.CATEGORY_NICKNAME;
    let FixedRightTop = action.FIXED_RIGHT_TOP;
    let FixedRightBottom = action.FIXED_RIGHT_BOTTOM;
    let TopMenu = action.TOP_MENU;
    let NavigationAlphabet = action.NAVIGATION_ALPHABET;
    let FixedLeftCategory = action.FIXED_LEFT_CATEGORY;
    let FirstOrderGift = action.FirstOrderGift;

    let CategoryResponseRule = action.CATEGORY_RESPONSE_RULE;

    let
        CategoryObject,
        Category,
        CategoryScrollTopObject,
        CategoryScrollTop;

    switch( action.type ){
        case HOME.PRESS_UP_DOWN_STATIC: 
            return Object.assign({},state,{
                UpDownKeyCodeStatic: action.keyCode
            })
        break;
        case HOME.PRESS_UP_DOWN_FIXED: 
            return Object.assign({},state,{
                UpDownKeyCodeFixed: action.keyCode
            })
        break;
        case HOME.SEARCHHISTORY: 
            return Object.assign({},state,{
                SearchHistory: action.SearchHistory
            })
        break;
        case HOME.SWITCHPRODUCTS: 
            return Object.assign({},state,{
                SwitchProducts: action.SwitchProducts
            })
        break;
        // case HOME.SEARCH_BORDER: 
        //     return Object.assign({},state,{
        //         SearchResults:Object.assign({},state.SearchResults,{
        //             border: action.border
        //         })
        //     })
        // break;
        // case HOME.DEFAULTMODULE: 
        //     return Object.assign({},state,{
        //         DefaultModule: action.DefaultModule
        //     })
        // break;
        case HOME.DEFAULTPRODUCTS: 
            return Object.assign({},state,{
                DefaultProducts: action.DefaultProducts
            })
        // break;
        // case HOME.SEARCH_RESULTS_DOWN: 
        //     return Object.assign({},state,{
        //         SearchResults:Object.assign({},state.SearchResults,{
        //             down: action.down,
        //             DefaultModule: action.DefaultModule,
        //         })
        //     })
        // break;
         case HOME.SEARCH_RESULTS_STATIC: 
            return Object.assign({},state,{
                SearchResultsStatic:Object.assign({},state.SearchResultsStatic,{
                    down: action.down,
                    results: action.results,   // 原数据
                    suggestList: action.suggestList,   // 处理后的数据
                    suggestProductList: action.suggestProductList, // 处理后的数据
                    DefaultModule: action.DefaultModule,
                    // DefaultProducts: action.DefaultProducts
                })
            })
        break;
        case HOME.SEARCH_RESULTS_FIXED: 
            return Object.assign({},state,{
                SearchResultsFixed:Object.assign({},state.SearchResultsFixed,{
                    down: action.down,
                    results: action.results,   // 原数据
                    suggestList: action.suggestList,   // 处理后的数据
                    suggestProductList: action.suggestProductList, // 处理后的数据
                    DefaultModule: action.DefaultModule,
                    // DefaultProducts: action.DefaultProducts
                })
            })
        break;
        case HOME.SEARCH_MYTIMER_STATIC: 
            return Object.assign({},state,{
                SearchInnerStatic:Object.assign({},state.SearchInnerStatic,{
                    myTimer: action.myTimer
                })
            })
        break;
         case HOME.SEARCH_MYTIMER_FIXED:
            return Object.assign({},state,{
                SearchInnerFixed:Object.assign({},state.SearchInnerFixed,{
                    myTimer: action.myTimer
                })
            })
        break;
         case HOME.SEARCH_INNER_PLACEHOLDER_STATIC: 
            return Object.assign({},state,{
                SearchInnerStatic:Object.assign({},state.SearchInnerStatic,{
                    placeholder: action.placeholder
                })
            })
        break;
        case HOME.SEARCH_INNER_PLACEHOLDER_FIXED: 
            return Object.assign({},state,{
                SearchInnerFixed:Object.assign({},state.SearchInnerFixed,{
                    placeholder: action.placeholder
                })
            })
        break;
        case HOME.SEARCH_INNER_PLACEHOLDERS_STATIC:
            return Object.assign({},state,{
                SearchInnerStatic:Object.assign({},state.SearchInnerStatic,{
                    placeholders: action.placeholders
                })
            })
        break;
        case HOME.SEARCH_INNER_PLACEHOLDERS_FIXED:
            return Object.assign({},state,{
                SearchInnerFixed:Object.assign({},state.SearchInnerFixed,{
                    placeholders: action.placeholders
                })
            })
        break;
        // case HOME.SEARCH_INNER_VALUE:
        // return Object.assign({},state,{
        //         SearchInner:Object.assign({},state.SearchInner,{
        //             value: action.value
        //         })
        //     })
        // break;
        case HOME.FIXED_LEFT_CATEGORY:
            return Object.assign({},state,{
                FixedLeftCategory
            });
            break;
        case HOME.CATEGORY_SCROLL_TOP:
            CategoryScrollTopObject = { ID: action.NODES_NAME, scrollTop: action.SCROLL_TOP, content: action.CONTENT }
            CategoryScrollTop = [...state.CategoryScrollTop, CategoryScrollTopObject]
            return Object.assign({},state,{
                CategoryScrollTop
            })
            break;
        case HOME.NAVIGATION_ALPHABET:
            return Object.assign({},state,{
                NavigationAlphabet
            });
            break;
        case HOME.TOP_MENU:
            return Object.assign({},state,{
                TopMenu
            });
            break;
        case HOME.FIXED_RIGHT_TOP:
            return Object.assign({},state,{
                FixedRightTop
            });
            break;
        case HOME.FIXED_RIGHT_BOTTOM:
            return Object.assign({},state,{
                FixedRightBottom
            });
            break;
        case HOME.SEARCH_TRIM:
            return Object.assign({},state,{
                SearchTrim
            });
            break;
        case HOME.BRAND:
            return Object.assign({},state,{
                BrandList
            });
            break;
        case HOME.TOP_CAROUSEL:
            return Object.assign({},state,{
                TopCarousel
            });
            break;
        case HOME.CATEGORY:
            CategoryObject = {
                ID: CategoryId,
                Response: CategoryResponse,
                Rule: CategoryResponseRule
            }
            Category = [...state.Category, CategoryObject]
            return Object.assign({},state,{
                Category
            });
            break;
        case HOME.CATEGORY_HOVER:
            return Object.assign({},state,{
                CategoryHover,
                CategoryHoverNickName
            });
            break;
        case HOME.FIRSTORDERGIFT:
            return Object.assign({},state,{
                FirstOrderGift
            });
            break;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/home.js